import {
    FileSuggestion,
    SubstrateSearchSuggestionsResponse,
    SubstrateSearchSuggestionsResponseFileSuggestion,
    SubstrateSearchSuggestionsResponseOdspFileGroup,
    Suggestion,
    SuggestionKind,
    SuggestionSet,
} from 'owa-search-service';
import referenceAttachment from 'owa-service/lib/factory/referenceAttachment';
import { AttachmentConstants } from 'owa-attachment-model-store';
import { REFERENCE_ATTACHMENT_TYPE } from 'owa-attachment-type-constants';

/**
 * Parses 3S suggestions response and converts it to a SuggestionSet.
 */
export default function convertSubstrateSuggestionsResponseToSuggestionSet(
    response: SubstrateSearchSuggestionsResponse
): SuggestionSet {
    if (!response || !response.Groups) {
        throw new Error('Substrate suggestions response "Groups" should not be null.');
    }

    // Array of parsed suggestions to return.
    const suggestions: Suggestion[] = [];

    // Iterate over groups of suggestions and convert to known suggestion types.
    for (const group of response.Groups) {
        switch (group.Type) {
            case 'File':
                const convertedFileSuggestions = (group as SubstrateSearchSuggestionsResponseOdspFileGroup).Suggestions.map(
                    convertToFileSuggestion
                );
                suggestions.push(...convertedFileSuggestions);
                break;
            default:
                break;
        }
    }

    return {
        Suggestions: suggestions,
        IsComplete: true,
        TraceId: response.Instrumentation.TraceId,
    };
}

function convertToFileSuggestion(
    suggestion: SubstrateSearchSuggestionsResponseFileSuggestion
): FileSuggestion {
    const FileSuggestion: FileSuggestion = {
        kind: SuggestionKind.File,
        AttachmentType: getAttachmentTypeForFileSuggestion(suggestion),
        DateTimeCreated: suggestion.DateCreated + '.000Z',
        DateTimeLastAccessed: suggestion.DateAccessed,
        FileName: suggestion.FileName,
        FileExtension: suggestion.FileExtension,
        FileUrl: suggestion.AccessUrl,
        ReferenceId: suggestion.ReferenceId,
        FileAuthor: suggestion.Author,
        FileType: suggestion.FileType,
        HighlightedDisplayText: suggestion.Text,
    };
    return FileSuggestion;
}

function getAttachmentTypeForFileSuggestion(
    suggestion: SubstrateSearchSuggestionsResponseFileSuggestion
) {
    return referenceAttachment({
        __type: REFERENCE_ATTACHMENT_TYPE,
        Name: suggestion.FileName,
        AttachmentIsFolder: false,
        IsInline: false,
        ProviderType: AttachmentConstants.providers.ONE_DRIVE_PRO, // 3S only supports OneDrivePro for now
        AttachLongPathName: suggestion.AccessUrl,
    });
}
